<template>
  <el-select clearable @change="handleChange" :value="data" placeholder="请先选择运营商" filterable :disabled="disabled">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in brand" :key="index"></el-option>
  </el-select>
</template>

<script>
import { getCascade } from "@/services/deviceType";

export default {
  name: "brand",
  props: {
    value: {},
    operator: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { data: "", brand: [] };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    operator: {
      immediate: true,
      handler(value) {

        if (value) {
          this.loadData(value);
        } else {
          this.brand = [];
        }
      }
    },
    value: {
      immediate: true,
      handler(value) {
        this.data = value;
      }
    },
    
  },

  methods: {
    handleChange(value) {
      let find = this.brand.find((item, i) => {
        return item.value == value;
      });
      if (find == undefined) {
        find = {};
      }
      this.$emit("input", value);
      this.$emit("change", value);
      this.data = value;
    },
    async loadData(operator) {
      this.brand = [];
      this.data = "";
      // this.$emit("input", "");
      if (operator) {
        const response = await getCascade({ operatorIds: operator.value });
        if (response && response.data.brand) {
          this.brand = response.data.brand.map((item, i) => {
            return { name: item.brand, value: item.brand };
          });
          this.data = this.value;
        }
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/operation/Brand.vue